module.exports = __webpack_public_path__ + "static/img/全球司库管理云5.6e687d6f.png";